
import { Service } from "../store/service";
const Api = new Service();

export const getFirstLetter = (value) => (value ? value.charAt(0) : '');



// class base constructor
// export class fetchUserAccount {
//     constructor() {
//          Api.getRequest(`fetch-user-validated-bank-account`)
//             .then(data => {
//                 console.log("bank Accounts", data);
//                 if (data.data.success) {
//                     this.userAccounts = data.data.banks;
//                 } else {
//                     this.$toast.error(data.error);
//                 }
//             }).catch((err) => {
//                 this.loading = false;
//                 console.log(err);
//                 // this.$toast.error("please check your network and refresh the page");
//             });
//     }
// }

// function base
export async function fetchUserAccount() {
    try {
        const data = Api.getRequest(`fetch-user-validated-bank-account`)
        if (data) {
          return data;
        } else {
          // Assuming you don't have `this` context in this helper, avoid using `this.$toast`
          // You can maybe return or throw the error, or handle it as needed
          console.error(data.error)
          return null
        }
      } catch (err) {
        console.log(err)
        return null
      }
    
}


export async function fetchNewLandlordDashboard() {
    try {
        const data = Api.getRequest(`new-dashboard`)
        if (data) {
          return data;
        } else {
          // Assuming you don't have `this` context in this helper, avoid using `this.$toast`
          // You can maybe return or throw the error, or handle it as needed
          console.error(data.error)
          return null
        }
      } catch (err) {
        console.log(err)
        return null
      }
    
}


// export async function fetchUserAccount() {
//     try {
//       const data = await Api.getRequest(`fetch-user-validated-bank-account`)
//       if (data.data.success) {
//         return data.user
//       } else {
//         // Assuming you don't have `this` context in this helper, avoid using `this.$toast`
//         // You can maybe return or throw the error, or handle it as needed
//         console.error(data.error)
//         return null
//       }
//     } catch (err) {
//       console.log(err)
//       return null
//     }
//   }

// export function getData(endpoint) {
//     return apiClient.get(endpoint)
//       .then(response => response.data)
//       .catch(error => {
//         console.error('GET error:', error)
//         throw error
//       })
//   }